export {default as Splunk} from './splunk'